import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import PGError from '../assets/images/error-state.png';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";

const propTypes = {
  message: PropTypes.string.isRequired,
  reload: PropTypes.func.isRequired,
};

export default function ErrorInfo({ message, reload }) {
    return <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ width: '600px', textAlign: 'center' }}>
            <Typography sx={{ fontSize: 34, fontWeight: 700, my: 2 }}>{message.title}</Typography>
            <img className="error-img" src={PGError} alt="Some Error Occurred..." />
            <Typography sx={{ fontSize: 16, fontWeight: 600, my: 1 }}>{message.subtitle}</Typography>
            <Button
                variant="contained"
                size="large"
                onClick={() => reload()}
                sx={{
                    my: 2,
                    px: 2,
                    py: 1,
                    backgroundColor: '#23B6E4',
                    color: '#FFFFFF',
                    fontWeight: 600,
                    fontSize: 15,
                    '&:hover': {
                        backgroundColor: '#22a3cb',
                    },
                }}
            >
                TRY AGAIN
            </Button>
        </Box>
    </Box>;
}

ErrorInfo.propTypes = propTypes;